// features in navigation
import nav_telematic_image from "@/assets/images/navbar/telematic.jpg";
import nav_telematic_thumbnail from "@/assets/images/navbar/telematic_thumbnail.jpg";
import nav_compliance_image from "@/assets/images/navbar/compliance.jpg";
import nav_compliance_thumbnail from "@/assets/images/navbar/compliance_thumbnail.jpg";
import nav_alerts_image from "@/assets/images/navbar/alerts.jpg";
import nav_alerts_thumbnail from "@/assets/images/navbar/alerts_thumbnail.jpg";
import nav_reports_image from "@/assets/images/navbar/reports.jpg";
import nav_reports_thumbnail from "@/assets/images/navbar/reports_thumbnail.jpg";

// Industries icons
import Agriculture_icon from "@/assets/icons/industries/agriculture.svg?react";
import Bus_icon from "@/assets/icons/industries/bus.svg?react";
import Car_share_icon from "@/assets/icons/industries/car-share.svg?react";
import Construction_icon from "@/assets/icons/industries/construction.svg?react";
import Cube_icon from "@/assets/icons/industries/cube.svg?react";
import Emergency_services_icon from "@/assets/icons/industries/emergency-services.svg?react";
import Globe_icon from "@/assets/icons/industries/globe-alt.svg?react";
import Government_icon from "@/assets/icons/industries/government.svg?react";
import Key_icon from "@/assets/icons/industries/key.svg?react";
import Ship_icon from "@/assets/icons/industries/ship.svg?react";
import Truck_icon from "@/assets/icons/industries/truck.svg?react";
import {LEGACY_URL} from "@/utils/api/Urls";

export const ROUTES = {
  home: "/",
  solutions: "/solutions",
  compareDevices: "/solutions/compare-devices",
  trackingDevices: "/solutions/devices",
  product: "/solutions/devices/:deviceId",

  industries: "/industries",
  industryDetails: "/industries/:type",

  whyTrackmate: "/why-trackmate",
  features: "/why-trackmate/features",
  featureDetail: "/why-trackmate/features/:type",
  getTrackmate: "/why-trackmate/get-trackmate",

  subscriptionPlans: "/plans",

  resources: "/resources",
  aboutUs: "/resources/about",
  contactUs: "/resources/contact",
  fleetInquiry: "/resources/fleet-inquiry",
  becomeDealer: "/resources/become-installer",
  faq: "/resources/FAQ",
  installationGuide: "/resources/installation-guide",
  APIintegration: "/resources/api-integration",

  helpCenter: "/help-center",
  troubleshooting: "/help-center/troubleshooting",
  articleDetails: "/help-center/troubleshooting/article",

  cart: "/cart",
  checkout: "/checkout",

  fleetInquiryForm: "/fleet-inquiry-form",
  login: "/login",
  legacyLogin: LEGACY_URL + "/en/Account/Login",
  legacySignUp: LEGACY_URL + "/profile/Home/SignUp",
  findDealer: "/resources/find-installer",
};

export const FEATURES = {
  telematics: "telematics",
  compliance: "compliance",
  alerts: "alerts",
  reports: "reports",
};

export const featureTypes = [
  FEATURES.telematics,
  FEATURES.compliance,
  FEATURES.alerts,
  FEATURES.reports,
];

export const INDUSTRIES = {
  carShare: "car-share",
  carRental: "car-rental",
  truckingTransport: "trucking-transport",
  tourismRecreation: "tourism-recreation",
  truckingDelivery: "trucking-delivery",
  shippingMaritime: "shipping-maritime",
  publicTransport: "public-transport",
  emergencyService: "emergency-service",
  governmentMunicipalities: "government-municipalities",
  agriculture: "agriculture",
  constructionPlumbing: "construction-plumbing",
};

export const industriesTypes = [
  INDUSTRIES.carShare,
  INDUSTRIES.carRental,
  INDUSTRIES.truckingTransport,
  INDUSTRIES.tourismRecreation,
  INDUSTRIES.truckingDelivery,
  INDUSTRIES.shippingMaritime,
  INDUSTRIES.publicTransport,
  INDUSTRIES.emergencyService,
  INDUSTRIES.governmentMunicipalities,
  INDUSTRIES.agriculture,
  INDUSTRIES.constructionPlumbing,
];

// ------------Header-----------------
export const navMenu = [
  { path: ROUTES.solutions, title: "Solutions", submenu: true },
  { path: ROUTES.industries, title: "Industries", submenu: true },
  { path: ROUTES.whyTrackmate, title: "Why Trackmate" },
  { path: ROUTES.subscriptionPlans, title: "Plans" },
  { path: ROUTES.resources, title: "Resources", submenu: true },
];

export const industriesRoutes = [
  {
    path: `${ROUTES.industries}/${INDUSTRIES.carShare}`,
    title: "Car Share",
    Icon: Car_share_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.carRental}`,
    title: "Car Rental",
    Icon: Key_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.truckingTransport}`,
    title: "Trucking & transport",
    Icon: Truck_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.tourismRecreation}`,
    title: "Tourism & recreation",
    Icon: Globe_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.truckingDelivery}`,
    title: "Trucking & delivery services",
    Icon: Cube_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.shippingMaritime}`,
    title: "Shipping and maritime",
    Icon: Ship_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.publicTransport}`,
    title: "Public transportation",
    Icon: Bus_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.emergencyService}`,
    title: "Emergency services",
    Icon: Emergency_services_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.governmentMunicipalities}`,
    title: "Government & municipalities",
    Icon: Government_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.agriculture}`,
    title: "Agriculture",
    Icon: Agriculture_icon,
  },
  {
    path: `${ROUTES.industries}/${INDUSTRIES.constructionPlumbing}`,
    title: "Construction, plumbing, HVAC",
    Icon: Construction_icon,
  },
];

export const featuresRoutes = [
  {
    path: `${ROUTES.features}?feature=${FEATURES.telematics}`,
    title: "Telematics",
    url: nav_telematic_image,
    thumbnail: nav_telematic_thumbnail
  },
  {
    path: `${ROUTES.features}?feature=${FEATURES.compliance}`,
    title: "Compliance",
    url: nav_compliance_image,
    thumbnail: nav_compliance_thumbnail
  },
  {
    path: `${ROUTES.features}?feature=${FEATURES.alerts}`,
    title: "Alerts",
    url: nav_alerts_image,
    thumbnail: nav_alerts_thumbnail
  },
  {
    path: `${ROUTES.features}?feature=${FEATURES.reports}`,
    title: "Reports",
    url: nav_reports_image,
    thumbnail: nav_reports_thumbnail
  },
];

export const resourcesRoutesCompany = [
  { path: ROUTES.contactUs, title: "Contact us" },
  { path: ROUTES.aboutUs, title: "About us" },
  { path: ROUTES.fleetInquiry, title: "Fleet Inquiry" },
  { path: ROUTES.becomeDealer, title: "Become an Installer" },
  { path: ROUTES.findDealer, title: "Find an Installer" },
];

export const resourcesRoutesLearn = [
  { path: ROUTES.resources, title: "Resources" },
  { path: ROUTES.helpCenter, title: "Help Center" },
  { path: ROUTES.installationGuide, title: "Installation guides" },
  // { path: ROUTES.APIintegration, title: "API Integrations" },
];

//-------------Footer ------------------
export const companyRoutes = [
  { path: ROUTES.aboutUs, title: "About us" },
  { path: ROUTES.contactUs, title: "Contact" },
  { path: ROUTES.fleetInquiry, title: "Fleet Inquiry" },
  { path: ROUTES.becomeDealer, title: "Become an installer" },
];

export const productRoutes = [
  { path: ROUTES.solutions, title: "Trackers" },
  { path: ROUTES.subscriptionPlans, title: "Plans" },
  { path: ROUTES.features, title: "Features" },
  { path: ROUTES.whyTrackmate, title: "Benefits" },
];

export const resourcesRoutes = [
  { path: ROUTES.helpCenter, title: "Help Center" },
  { path: ROUTES.faq, title: "FAQ" },
  { path: ROUTES.installationGuide, title: "Installation guides" },
  // { path: ROUTES.APIintegration, title: "APIs" },
];

export const legalLinks = [
  { label: "Privacy policy", link: "https://mobile.trackmategps.com/html/privacy-policy.html" },
  { label: "User Agreement", link: "https://mobile.trackmategps.com/html/user-agreement.html" },
];

// ------------------Breadcrumbs------------------
//  Breadcrumbs main routes
export const mainRoutes = [
  ...navMenu,
  { path: ROUTES.helpCenter, title: "Help Center" },
  { path: ROUTES.cart, title: "Shopping Cart" },
  { path: ROUTES.checkout, title: "Checkout" },
  { path: ROUTES.solutions, title: "Solutions" },
];

// Breadcrumbs sub routes
export const subRoutes = [
  ...resourcesRoutesCompany,
  { path: ROUTES.features, title: "Main features" },
  { path: ROUTES.getTrackmate, title: "Get Trackmate" },
  { path: ROUTES.installationGuide, title: "Installation guides" },
  { path: ROUTES.APIintegration, title: "API Integrations" },
  { path: ROUTES.faq, title: "FAQs" },
  { path: ROUTES.troubleshooting, title: "Troubleshooting" },
  { path: ROUTES.trackingDevices, title: "Tracking devices" },
  { path: ROUTES.compareDevices, title: "Compare devices" },
];
